import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-layout',
  templateUrl: './simple-layout.component.html',
  styleUrls: ['./simple-layout.component.scss']
})
export class SimpleLayoutComponent implements OnInit {

  footerEnabled: boolean = false;

  constructor() { }

  ngOnInit() {}

  onActivate(component) {
    if (component.hasFooter == true) {
      this.footerEnabled = true;
    }
  }

  onDeactivate(component) {
    this.footerEnabled = false;
  }

}




// WEBPACK FOOTER //
// ./src/app/layouts/simple-layout.component.ts